import { render, staticRenderFns } from "./SlackMessageEditor.vue?vue&type=template&id=4fff0a6e&scoped=true"
import script from "./SlackMessageEditor.vue?vue&type=script&lang=js"
export * from "./SlackMessageEditor.vue?vue&type=script&lang=js"
import style0 from "./SlackMessageEditor.vue?vue&type=style&index=0&id=4fff0a6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fff0a6e",
  null
  
)

export default component.exports